import React from "react";
import { observer } from "mobx-react";

import { SportOfferContext } from "@gp/components";
import LiveViewStore from "@state/stores/offer/live/LiveViewStore";
import { getSportOfferKey } from "@utils/offer";
import { TFlatVirtualizedSportItem } from "@data-types/offer/live/TFlatVirtualizedSportItem";

import { LiveSportHeader } from "@features/offer/desktop/sport-header/SportHeader";
import VirtualizedSportOffer from "./LiveVirtualizedOfferList";
import { VirtualizedListItemType } from "@data-types/offer/live/VirtualizedListItemTypeEnum";

export const LiveVirtualizedOfferSportItem = observer(
	function LiveVirtualizedOfferSportItem(props: {
		spList: TFlatVirtualizedSportItem[];
		isScrollRestoreWorking: boolean;
		store: LiveViewStore;
		listHeight: number;
	}) {
		const [wrapperDivRef, setWrapperDivRef] =
			React.useState<HTMLDivElement | null>(null);

		const sp = props.spList[0].sport;
		const eventCount =
			//@ts-expect-error
			props.spList[0].type == VirtualizedListItemType.sport
				? //@ts-expect-error
					props.spList[0].eventCount
				: 0;

		if (sp == null) {
			console.error("Expected sport, got null.");
			return null;
		}

		const isSpCollapsed = props.store.collapsedSports.includes(sp.id);

		return (
			<SportOfferContext.Provider value={sp} key={getSportOfferKey(sp)}>
				<div ref={setWrapperDivRef}>
					<LiveSportHeader
						visible={!isSpCollapsed}
						eventCount={eventCount}
						isLive
						sport={sp}
						onShowHide={props.store.toggleSportCollapse}
					/>
					{!isSpCollapsed && (
						<VirtualizedSportOffer
							isScrollRestoreWorking={
								props.isScrollRestoreWorking
							}
							flatSport={props.spList}
							store={props.store}
							listHeight={props.listHeight}
							isSpCollapsed={isSpCollapsed}
							parentWrapperDiv={wrapperDivRef}
						/>
					)}
				</div>
			</SportOfferContext.Provider>
		);
	}
);
